import { useCodeBlockButton } from '../insertButtonHooks/useCodeBlockButton'
import { SingleMenuDropdownContext } from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdownStore'
import { useContext } from 'react'
import { SingleMenuDropdownItem } from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdownItem'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const InsertCodeBlockButton = () => {
  const view = useEditorView()
  const dropdownStore = useContext(SingleMenuDropdownContext)
  const addCodeBlock = useCodeBlockButton(view)
  const onClick = () => {
    addCodeBlock()
    dropdownStore?.hardClose()
  }

  return (
    <SingleMenuDropdownItem icon={<ToolbarIcon name={IconName.Code4} />} label="Code Block" handleClick={onClick} />
  )
}
